'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.FaresOptimizer.Common.SharedFbcUtil', dependencies).factory('FaresOptimizerSharedFbcService', require('./services/FaresOptimizerSharedFbcService'));